<template>
  <div style="overflow-y: auto; height: 100%; padding-top: 10px;" class="dataAccessConfiguration">
    <!-- <div class="title">新增接入</div> -->
    <a-form :form="fromDom" :label-col="formItemLayout.labelCol" :wrapper-col="formItemLayout.wrapperCol"
      :label-align="formItemLayout.labelAlign">
      <a-form-item label="设备类型" required>
        <div class="deviceTypeBox">
          <div v-for="item in deviceTypeList" :key="item.type" :class="{ av: item.type == deviceType }"
            @click="deviceTypeChange(item.type)">
            <span>{{ item.name }}</span>
          </div>
        </div>
      </a-form-item>
      <a-form-item label="设备名称">
        <a-input v-decorator="[
      'deviceName',
      { rules: [{ required: true, message: '请填写设备名称' }] },
    ]" placeholder="请输入内容" />
      </a-form-item>
      <a-form-item label="设备分类" style="width: 100%">
        <div style="display: flex">
          <a-select v-decorator="[
      'type',
      { rules: [{ required: true, message: '请选择设备分类' }] },
    ]" placeholder="请选择设备分类">
            <a-select-option v-for="item in typeList" :value="item.id" :key="item.id">{{ item.name }}</a-select-option>
          </a-select>
          <a-button type="link" @click="classificationVisible = true">分类管理</a-button>
        </div>
      </a-form-item>
      <a-form-item label="设备图片">
        <a-upload v-decorator="[
      'deviceImg',
      { rules: [{ required: true, message: '请上传设备图片' }] },
    ]" :showUploadList="false" name="file" :action="baseUrl + `/api/file/uploadOss`" :headers="headers"
          list-type="picture-card" @change="deviceImgChange">
          <img v-if="deviceImg" :src="deviceImg" alt="avatar" style="width: 102px; height: 102px" />
          <div v-else>
            <a-icon :type="loading ? 'loading' : 'plus'" />
            <div class="ant-upload-text">上传图片</div>
          </div>
        </a-upload>
      </a-form-item>
      <a-form-item label="数据源获取方式" style="width: 100%">
        <a-select v-decorator="[
      'dataGet',
      { rules: [{ required: true, message: '请选择获取方式' }] },
    ]" placeholder="请选择数据源获取方式">
          <a-select-option v-for="item in dataGetList" :value="item.value" :key="item.id">{{ item.name
            }}</a-select-option>
        </a-select>
      </a-form-item>
      <!-- api -->
      <div v-if="fromDom.getFieldValue('dataGet') != 2">
        <a-form-item label="请求方式" style="width: 100%" v-if="fromDom.getFieldValue('dataGet') == 1">
          <a-select v-decorator="[
      'request',
      { rules: [{ required: true, message: '请选择请求方式！' }] },
    ]" placeholder="请选择请求方式">
            <a-select-option v-for="item in requestList" :value="item.value" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
          <div class="ceshi">
            <a-form-item>
              <a-input v-decorator="[
      'url',
      { rules: [{ required: true, message: '请输入URL地址' }] },
    ]" placeholder="输入URL地址" style="margin-top: 15px" />
            </a-form-item>
          </div>
        </a-form-item>
        <a-form-item label="接口文件" v-if="fromDom.getFieldValue('dataGet') == 3 ||
      fromDom.getFieldValue('dataGet') == 1
      ">
          <a-table style="margin-bottom: 15px" :dataSource="fileList" :columns="fileListColumns"
            :rowKey="(record, index) => index" :pagination="false" bordered v-if="fileList.length">
            <template slot="action" slot-scope="text, record">
              <a-button type="primary" size="small" @click="downloadFun(record)">
                <i class="el-icon-download"></i>
                下载 </a-button><a-divider type="vertical" />
              <a-popconfirm title="确定删除吗？该删除不会撤销" ok-text="是" cancel-text="否" @confirm="handleDelete(text)">
                <a-button type="danger" size="small">
                  <i class="el-icon-delete"></i>
                  删除</a-button>
              </a-popconfirm>
            </template>
          </a-table>
          <div class="ceshi">
            <a-form-item>
              <a-upload :showUploadList="false" name="file" :multiple="true" :action="baseUrl + `/api/file/uploadOss`"
                :headers="headers" @change="fileListChange">
                <a-button type="primary" size="small" class="uploadAButton">
                  <loading-outlined v-if="fileListLoading"></loading-outlined>
                  <upload-outlined v-else></upload-outlined>
                  <i class="el-icon-upload2"></i>
                  上传文件
                </a-button>
              </a-upload>
            </a-form-item>
          </div>
        </a-form-item>
      </div>

      <!-- 数据库 -->
      <div v-else>
        <a-form-item label="数据库类型:">
          <a-select v-decorator="[
      'dataType',
      { rules: [{ required: true, message: '请选择数据库类型' }] },
    ]" placeholder="请选择数据库类型">
            <a-select-option v-for="item in dataTypeList" :value="item.value" :key="item.id">{{ item.name
              }}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item label="主机:">
          <a-input v-decorator="[
      'ip',
      { rules: [{ required: true, message: '请输入主机' }] },
    ]" placeholder="请输入主机" />
        </a-form-item>
        <a-form-item label="端口:">
          <a-input v-decorator="[
      'port',
      { rules: [{ required: true, message: '请输入端口' }] },
    ]" placeholder="请输入端口" />
        </a-form-item>
        <a-form-item label="数据库:">
          <a-input v-decorator="[
      'dataName',
      { rules: [{ required: true, message: '请输入数据库名称' }] },
    ]" placeholder="请输入数据库名称" />
        </a-form-item>
        <a-form-item label="表名:">
          <a-input v-decorator="[
      'tableName',
      { rules: [{ required: true, message: '请输入表名' }] },
    ]" placeholder="请输入表名" />
        </a-form-item>
        <a-form-item label="用户名:">
          <a-input v-decorator="[
      'userName',
      { rules: [{ required: true, message: '请输入用户名' }] },
    ]" placeholder="请输入用户名" />
        </a-form-item>
        <a-form-item label="密码:">
          <a-input v-decorator="[
      'passWord',
      { rules: [{ required: true, message: '请输入密码' }] },
    ]" placeholder="请输入密码" />
        </a-form-item>
      </div>
      <a-form-item label="接入来源" style="width: 100%">
        <a-select v-decorator="[
      'accessSource',
      { rules: [{ required: true, message: '请选择接入方' }] },
    ]" placeholder="请选择接入方">
          <a-select-option v-for="item in accessSourceList" :value="item.id" :key="item.id">{{ item.companyName
            }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item label="说明" style="width: 100%">
        <a-textarea v-decorator="['remark']" placeholder="请填写说明" :rows="4" showCount :maxlength="100" />
      </a-form-item>
      <a-form-item :wrapper-col="{ span: 14, offset: 2 }">
        <a-space :size="8">
          <a-button @click="initFromData"><i class="el-icon-refresh"></i> 重置</a-button>
          <a-button type="primary" @click="subimtFrom"><i class="el-icon-check"></i> 保存</a-button>
        </a-space>
      </a-form-item>
      <a-modal v-model="showModal" title="变更记录" @ok="handleOk">
        <a-form-item label="变更记录">
          <a-input style="margin-left: 20px" v-decorator="[
      'remark2',
      { rules: [{ required: true, message: '请填写变更说明' }] },
    ]" />
        </a-form-item>
      </a-modal>
    </a-form>
    <classification :visible="classificationVisible" @cancel="classificationCancel()" />
  </div>
</template>
<script>
import store from "@/store/index";
import moment from "moment";
import * as API_Ques from "@/api/dataAccess/accessApi";
export default {
  props: {
    componentsType: {
      type: String,
      default: "add",
    },
    deviceId: {
      type: String | Number,
      default: "",
    },
    activeKey: {
      type: String | Number,
      default: "",
    },
  },
  data() {
    return {
      showModal: false,
      http: process.env.VUE_CONTEXT_PATH,
      baseUrl: process.env.VUE_APP_BASE_API,
      headers: {
        system: 0,
        token: store.state.token,
      },
      formItemLayout: {
        labelAlign: "left",
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 16,
        },
      },
      deviceTypeList: [
        {
          name: "硬件",
          type: "1",
        },
        {
          name: "软件",
          type: "2",
        },
      ],
      deviceType: "1",
      typeList: [],
      dataGetList: [
        { value: "1", id: 0, name: "api", }, 
        { value: "2", id: 0, name: "数据库", },
        { value: "3", id: 0, name: "蓝牙", }, 
        { value: " 4", id: 0, name: "EXCEL/CSV", },
      ],
      dataTypeList: [
        {
          value: "1",
          id: 0,
          name: "mYsql",
        },
        {
          value: "2",
          id: 0,
          name: "Sql server",
        },
        {
          value: "3",
          id: 0,
          name: "Oracle",
        },
      ],
      accessSourceList: [],
      requestList: [
        {
          value: "1",
          name: "get",
        },
        {
          value: "2",
          name: "post",
        },
      ],
      fileList: [],
      fileListColumns: [
        {
          title: "文件名",
          dataIndex: "fileName",
          key: "fileName",
          align: "center",
          width: 80,
        },
        {
          title: "上传时间",
          dataIndex: "time",
          key: "time",
          align: "center",
          width: 80,
        },
        {
          title: "操作",
          dataIndex: "action",
          key: "action",
          width: 200,
          align: "center",
          scopedSlots: {
            customRender: "action",
          },
        },
      ],
      fileListLoading: false,
      fromDom: this.$form.createForm(this, {
        name: "dynamic_rule",
        type: "dynamic_rule",
        deviceImg: "dynamic_rule",
        dataGet: "dynamic_rule",
        request: "dynamic_rule",
        accessSource: "dynamic_rule",
        remark2: "dynamic_rule",
        onValuesChange: (props, values) => {
          this.detailsData = {
            ...this.detailsData,
            ...values,
          };
          if (values.dataGet) {
            const data = this.detailsData;
            delete data.dataGet;
            this.$nextTick(() => {
              this.fromDom.setFieldsValue(data);
            });
          }
        },
      }),
      deviceImg: "",
      deviceImgLoading: false,
      detailsData: {},
      classificationVisible: false,
    };
  },
  watch: {
    deviceId: function () {
      this.init();
    },
    activeKey: function () {
      this.init();
    },
  },
  methods: {
    deviceTypeChange(dType) {
      if (this.deviceType == dType) {
        return false;
      }
      this.deviceType = dType;
      console.log(this.deviceType);
    },
    // 文件下载
    downloadFun(row) {
      location.href = row.url;
    },
    // 文件列表删除一项
    handleDelete(index) {
      const list = this.fileList;
      list.splice(index, 1);
      this.fileList = list;
    },
    // 接口文件上传
    fileListChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.fileListLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.fileListLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          const list = this.fileList || [];
          res.data.time = moment(res.data.time).format("YYYY-MM-DD");
          list.push(res.data);
          this.fileList = list;
        }
      }

      if (info.file.status === "error") {
        this.fileListLoading = false;
        this.$message.error("上传失败");
      }
    },
    deviceImgChange(info) {
      console.log(info);
      if (info.file.status === "uploading") {
        this.deviceImgLoading = true;
        return;
      }
      if (info.file.status === "done") {
        this.deviceImgLoading = false;
        const res = info.file.response;
        if (res.code == 200) {
          this.deviceImg = res.data.url;
        }
      }

      if (info.file.status === "error") {
        this.deviceImgLoading = false;
        this.$message.error("上传失败");
      }
    },
    getData() {
      let param = {
        system: 1,
      };
      API_Ques.getCompanyList(param).then((res) => {
        const { code, data, msg } = res;
        if (code == 0 || code == 200) {
          console.log(data);
          this.accessSourceList = data;
          // this.pagination.total = data.total * 1;
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 表格重置
    initFromData() {
      this.fromDom.resetFields();
    },
    // 表单添加
    subimtFrom() {
      this.fromDom.validateFieldsAndScroll((errors, values) => {
        console.log(values);
        if (!errors) {
          // 接口调用，成功后初始化所有数据
          // const portFileList = !this.fileList.length
          //   ? []
          //   : this.fileList.map((item) => item.url);
          values.deviceType = this.deviceType;
          // values.portFile = !portFileList.length ? "" : portFileList.join(",");
          // console.log(this.fileList);
          values.portFile = JSON.stringify(this.fileList);
          values.deviceImg =
            typeof values.deviceImg == "string"
              ? values.deviceImg
              : values.deviceImg.file.response.data.url;
          if (this.componentsType == "add") {
            this.adddeviceFieFun(values);
          } else {
            this.showModal = true;
            // this.editdeviceFieFun(values);
          }
        }
      });
    },
    handleOk(e) {
      this.fromDom.validateFieldsAndScroll((errors, values) => {
        if (!errors) {
          this.showModal = false;
          this.editdeviceFieFun(values);
        }
      });
    },
    // 新增
    adddeviceFieFun(body) {
      API_Ques.adddeviceFie(body).then((res) => {
        const { code, msg } = res;
        if (code == 0 || code == 200) {
          this.$message.success("添加成功！");
          // this.initFromData();
          this.$router.go(-1);
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 编辑
    editdeviceFieFun(body) {
      API_Ques.editdeviceFie({
        ...this.detailsData,
        portFile: JSON.stringify(this.fileList),
        ...body,
      }).then((res) => {
        const { code, msg } = res;
        if (code == 0 || code == 200) {
          this.$message.success("操作成功！");
          this.$emit("init");
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 接入配置详情
    findDeviceInfoFun() {
      API_Ques.findDeviceInfo({
        deviceId: this.deviceId,
      }).then((res) => {
        console.log(res);
        const { code, msg, data } = res;
        if (code == 0 || code == 200) {
          const { deviceType, portFile, dataGet } = data;
          this.fileList = portFile ? JSON.parse(portFile) : [];
          this.deviceType = deviceType;
          this.deviceImg = data.deviceImg;
          this.detailsData = data;
          this.fromDom.setFieldsValue({
            dataGet,
          });
          return false;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 获取分类列表
    getListDeviceType() {
      API_Ques.listDeviceType({}).then((res) => {
        const { code, msg, data } = res;
        if (code == 0 || code == 200) {
          this.typeList = data;
          return;
        }
        this.$message.error(msg || "接口异常，请联系管理员");
      });
    },
    // 关闭分类管理弹窗
    classificationCancel() {
      this.classificationVisible = false;
      this.fromDom.resetFields(["type"]);
      this.getListDeviceType();
      // 刷新分类管理下拉框列表
    },
    init() {
      this.getData();
      this.getListDeviceType();
      if (this.componentsType == "edit") {
        this.$nextTick(() => {
          this.fromDom.setFieldsValue({
            dataGet: "1",
          });
        });
        this.findDeviceInfoFun();
      }
    },
  },
  created() {
    this.init();
  },
};
</script>
<style scoped lang="less">
.title {
  position: relative;
  padding-left: 16px;
}

.title::after {
  content: " ";
  background: #1890ff;
  width: 3px;
  height: 12px;
  position: absolute;
  left: 0;
  top: 6px;
}

.deviceTypeBox {
  display: flex;
  align-items: center;

  >div {
    background: #21284b;
    font-size: 13px;
    border-radius: 60px;
    color: #bcbcbc;
    width: 120px;
    height: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    &:nth-of-type(1) {
      margin-right: 40px;
    }
  }

  .av {
    color: #1890ff;
    border: 1px solid #1890ff;
    background: transparent;
  }
}

.ceshi {
  .ant-form-item {
    margin: 0 !important;
  }
}

.ceshi {
  .ant-upload {
    .uploadAButton {
      background-color: #1890ff !important;
      color: #fff !important;
      height: 32px;
      line-height: 32px;      

      &:hover {
        opacity: .7;
      }
    }
  }
}
</style>